<template>
    <div class="row">
        <div class="col-6">
            <div class="chart">
                <div class="d-flex justify-content-between p-3">
                    <h1>Пассажиры</h1>
                    <select name="" id="a" v-model="type" class="custom-select w-50">
                        <option value="weekly">Неделя</option>
                        <option value="monthly">Месяц</option>
                        <option value="annual">Год</option>
                    </select>
                </div>
                <p class="justify-content-between pl-3">{{ passengersFromDate + ' - ' + passengersToDate }}</p>
                <apexchart ref="chart" height="400" type="area" :options="options" :series="series"></apexchart>
            </div>
        </div>
        <div class="col-6">
            <div class="chart">
                <div class="d-flex justify-content-between p-3">
                    <h1>Отченость суммы</h1>
                    <select name="" id="b" v-model="type" class="custom-select w-50">
                        <option value="weekly">Неделя</option>
                        <option value="monthly">Месяц</option>
                        <option value="annual">Год</option>
                    </select>
                </div>
                <p class="justify-content-between pl-3">{{ passengersFromDate + ' - ' + passengersToDate }}</p>
                <apexchart ref="barChart" height="400" type="bar" :options="optionsSecond" :series="seriesSecond"></apexchart>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PassengersDashboard",
        data() {
            return {
                type: 'weekly',
                options: {
                    chart: {
                        height: 350,
                        type: 'area',
                        id: 'chart1'
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: 'category',
                        categories: [],
                    },
                    tooltip: {
                        x: {
                            format: 'dd-MM-yy'
                        },
                    }
                },
                series: [
                    {
                        name: 'Продажа',
                        data: []
                    },
                    {
                        name: 'Возврат',
                        data: []
                    }
                ],
                optionsSecond: {
                    chart: {
                        height: 350,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        type: 'category',
                        categories: [],
                    },
                    fill: {
                        opacity: 1

                    }
                },
                seriesSecond: [
                    {
                        name: 'Продажа',
                        data: []
                    },
                    {
                        name: 'Возврат',
                        data: []
                    }
                ],
                passengersFromDate: '',
                passengersToDate: ''
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let data = {};
                data[this.type] = true;
                this.$api.get('dashboard.passengers', data)
                    .then(res => {
                        let data = res.data.data;
                        this.passengersFromDate = this.$moment(res.data.range.from.date).format('Y-MM-DD');
						this.passengersToDate = this.$moment(res.data.range.to.date).format('Y-MM-DD');
                        let series_one = [];
                        let second_one = [];
                        let series_two = [];
                        let second_two = [];
                        let categories = [];
                        data.forEach(item => {
                            categories.push(item.time);
                            series_one.push(item.count);
                            second_one.push(item.amount);
                            series_two.push(item.revert_count);
                            second_two.push(item.revert_amount);
                        });

                        let options = this.options;
                        let secondOptions = this.optionsSecond;
                        options.xaxis.categories = categories;
                        secondOptions.xaxis.categories = categories;

                        this.$refs.chart.updateOptions(options);
                        this.$refs.barChart.updateOptions(secondOptions);

                        let series = this.series;
                        let seriesSecond = this.seriesSecond;
                        series[0].data = series_one;
                        series[1].data = series_two;
                        seriesSecond[0].data = second_one;
                        seriesSecond[1].data = second_two;

                        this.$refs.chart.updateSeries(series);
                        this.$refs.barChart.updateSeries(seriesSecond);
                    })
            },
        },
        watch: {
            type: function () {
                this.init();
            }
        }
    }
</script>

<style scoped>

</style>
